import L from 'leaflet';
import React, {useEffect, useRef} from 'react';
import {useMap} from 'react-leaflet';

const ZoomOutButton: React.FC<{
  setSelectedFacility: React.Dispatch<React.SetStateAction<string | undefined>>;
}> = ({setSelectedFacility}) => {
  const map = useMap();

  const divRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const zoomOutButton = L.control.zoom({position: 'topleft'});

    zoomOutButton.onAdd = function () {
      const container = L.DomUtil.create(
        'div',
        'leaflet-control-zoom-out leaflet-bar leaflet-control'
      );

      const button = L.DomUtil.create(
        'a',
        'leaflet-control-zoom-out-button',
        container
      );
      button.innerHTML = '&#9899;';

      L.DomEvent.disableClickPropagation(button);
      L.DomEvent.on(button, 'click', function () {
        map.flyTo([0, 0], 1.2, {animate: true, duration: 1});
        setSelectedFacility(undefined);
      });

      const div = container;

      if (divRef.current) {
        divRef.current.appendChild(container);
      }

      return div;
    };

    zoomOutButton.addTo(map);

    return () => {
      zoomOutButton.remove();
    };
  }, [map]);

  return <div className="map-all-zoom" ref={divRef} draggable={false} />;
};

export default ZoomOutButton;
